import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { CustImgImpStepsComponent } from '@app/features/customer/dialog/import-steps/cust-img-imp-steps/cust-img-imp-steps.component';
import { DecDataImportStepsComponent } from '@app/features/decoded-data/dialog/import-steps/dec-data-import-steps/dec-data-import-steps.component';
import { DecImgImportStepsComponent } from '@app/features/decoded-data/dialog/import-steps/dec-img-import-steps/dec-img-import-steps.component';
import { DevImpStepsComponent } from '@app/features/device/dialogs/import-steps/dev-imp-steps/dev-imp-steps.component';
import { ProdImgImpStepsComponent } from '@app/features/product/dialog/import-steps/prod-img-imp-steps/prod-img-imp-steps.component';
import { ProdImgTempImpStepsComponent } from '@app/features/product/dialog/import-steps/prod-img-temp-imp-steps/prod-img-temp-imp-steps.component';
import { SalCondImgImpStepsComponent } from '@app/features/salesconditions/dialog/import-steps/sal-cond-img-imp-steps/sal-cond-img-imp-steps.component';
import { UserImpStepsComponent } from '@app/features/user/dialogs/import-steps/user-imp-steps/user-imp-steps.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { ImportTitles } from 'src/assets/features/import-steps/import-titles';

export interface StepsComponent {
  component: any;
  title: string;
}

const ComponentsList = {
  impproducts: ProdImgImpStepsComponent,
  impproductstemplatemedia: ProdImgTempImpStepsComponent,
  impdecoded: DecDataImportStepsComponent,
  impdecodedmedia: DecImgImportStepsComponent,
  imppromotionsmedia: SalCondImgImpStepsComponent,
  impusers: UserImpStepsComponent,
  impdevices: DevImpStepsComponent,
  impcustomers: CustImgImpStepsComponent
};

@Injectable({
  providedIn: 'root'
})
export class ImportStepsService {
  constructor(private translateService: TranslateService, private componentFactoryResolver: ComponentFactoryResolver) {}

  resolveComponent(type: string): Observable<StepsComponent> {
    const title: string = this.translateService.instant(ImportTitles[type]);
    const component = ComponentsList[type];
    return of({
      component,
      title
    } as StepsComponent);
  }
}
